export enum appNames{
    inaiaEu="inaia-eu",
    getGreenGold='green-gold',
    inaiaUk="inaia-uk"
}